import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ee665ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-bg-[#ffffff] !tw-w-[220px] tw-flex tw-flex-col tw-justify-between tw-items-start tw-flex-[1_0_0] tw-self-stretch tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-rounded-[6px] tw-border-solid tw-border-[#EFF0F1] tw-gap-[25px]" }
const _hoisted_2 = { class: "tw-font-Poppins tw-text-[12px] tw-font-[600] tw-text-[#211F58] tw-uppercase tw-leading-[100%] tw-tracking-[1.2px]" }
const _hoisted_3 = ["data-cy"]
const _hoisted_4 = { class: "tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[120%] tw-font-Poppins" }

import { PropType } from "vue";
import ToggleSwitch from "../common/toggleSwitch.vue";
import { getComponentUiText } from "@/utils/utilities";
interface option {
  title: string;
  value: boolean;
  action: (value: boolean) => void;
  dataCy: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentDisplayOptions',
  props: {
  listOption: {
    type: Array as PropType<option[]>,
    required: true,
    default: () => [],
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(getComponentUiText)(
          "app-component-assessment-display-options-heading-display-options-1",
        )), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.listOption, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "tw-flex tw-justify-between tw-items-center tw-w-full",
        "data-cy": `${item.dataCy}`
      }, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(item.title), 1),
        _createVNode(ToggleSwitch, {
          "is-checked": item.value,
          "data-cy": `assessment-display-options-${index}`,
          "data-status": item.value ? 'checked' : 'unchecked',
          color: "#2573E9",
          "onUpdate:isChecked": (value) => item.action(value)
        }, null, 8, ["is-checked", "data-cy", "data-status", "onUpdate:isChecked"])
      ], 8, _hoisted_3))
    }), 128))
  ]))
}
}

})